import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.VoiceManageInsuranceMessage,
  LocationVarKey.VoiceSendManageInsuranceText,
  LocationVarKey.VoiceManageInsuranceTextMessage,
  LocationVarKey.VoiceForwardManageInsurance,
  LocationVarKey.VoiceManageInsuranceEscalateTo,
  LocationVarKey.VoiceManageInsurancePhoneNumber
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page}>Manage Insurance</PageHeader>
      <TextAreaRow {...page} marginTop label=" Voice Message" keyName={LocationVarKey.VoiceManageInsuranceMessage} />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceSendManageInsuranceText} label="Send SMS" />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendManageInsuranceText, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoiceManageInsuranceTextMessage}
      />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceForwardManageInsurance} label="Escalate" />
      <DropdownRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceForwardManageInsurance, "0")}
        label="Send escalations to"
        marginTop
        keyName={LocationVarKey.VoiceManageInsuranceEscalateTo}
        options={[
          { label: "swivl Conversations", value: "swivl" },
          { label: "External Phone Number", value: "phone" }
        ]}
      />
      <Section
        {...page}
        hideIf={IF_ANY([
          IS_NOT_EQUAL(LocationVarKey.VoiceForwardManageInsurance, "1"),
          IS_EQUAL(LocationVarKey.VoiceManageInsuranceEscalateTo, "swivl")
        ])}
      >
        <InputRow {...page} keyName={LocationVarKey.VoiceManageInsurancePhoneNumber} label="External Phone Number" />
        <div className="cortexDescription">
          This is the direct line defined{" "}
          <a
            href="/properties/page/cortex/voice/voice-settings"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          . Only overwrite this if you have a different direct line for this use case!
        </div>
      </Section>
    </>
  );
}
